import { useRef, useEffect, useState } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";

export const useIsMobile = () => {
  const [mobile, setMobile] = useState(() => typeof window !== "undefined" && window.matchMedia("(max-width: 767px)").matches);
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 767px)");
    const fn = (e) => setMobile(e.matches);
    mq.addEventListener("change", fn);
    return () => mq.removeEventListener("change", fn);
  }, []);
  return mobile;
};

export const CinematicScene = ({ img, imgMobile, eager = false, className = "", children, ...rest }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const isMobile = useIsMobile();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"], layoutEffect: false });
  const scale = useTransform(scrollYProgress, [0, 1], [1.14, 1]);
  const y = useTransform(scrollYProgress, [0, 1], ["-4%", "4%"]);
  const opacity = useTransform(scrollYProgress, [0, 0.16, 0.84, 1], [0, 1, 1, 0]);
  const animated = !reduce && !isMobile;
  const src = isMobile && imgMobile ? imgMobile : img;

  return (
    <section ref={ref} className={`relative ${className}`} {...rest}>
      <div className="absolute inset-0 overflow-clip pointer-events-none" aria-hidden="true">
        <div className="sticky top-0 h-screen">
          <motion.img
            src={src}
            alt=""
            loading={eager ? "eager" : "lazy"}
            decoding="async"
            className="absolute inset-0 w-full h-full object-cover"
            style={animated ? { scale, y, opacity } : { opacity: 0.9 }}
          />
          <div className="scene-overlay absolute inset-0" />
        </div>
      </div>
      <div className="relative">{children}</div>
    </section>
  );
};
